import {
    animate,
    style,
    transition,
    trigger,
} from '@angular/animations';

export const enterAnimation = trigger('enterAnimation', [
    transition(
        ':enter',
        [
            style({ height: 0, opacity: 0 }),
            animate('0.5s ease-out',
                style({ height: 215, opacity: 1 }))
        ]
    ),
    transition(
        ':leave',
        [
            style({ height: 215, opacity: 1 }),
            animate('0.7s ease-in',
                style({ height: 0, opacity: 0 }))
        ]
    )
]);
